class PartialOverlay extends HTMLElement {
  constructor() {
    super();

    //wait for DY event
    document.addEventListener('dy:overlay:partial:init', () => {
        
      //initialize content from DY
      this.initDYContent();

      //close event listeners
      this.querySelector(".icon-close").addEventListener("click", () => { this.closeOverlay();});
      this.querySelector(".button--container p span").addEventListener("click", () => {this.closeOverlay();});

      //hide nav icon by firing custom event from other different emarsys integrated sections like the newsletter or split overlay
      document.addEventListener("partial:overlay:close", () => {this.toggleNudge();});

      //add css padding for nav icon
      this.toggleNudge("active");

      //init overlay event listeners
      document.querySelector(".header__icon--mail").addEventListener("click", () => {
        if(!document.querySelector(".header__icon--mail").classList.contains('nudge--active-open')) this.dispatchOverlayBackground();
      });

      //init real-time email validation. needed for heap in order to accurately track valid email submissions
      this.querySelector('#partial_overlay_email').addEventListener('change', () => {
        this.validateEmail(this.querySelector("#partial_overlay_email").value) ? this.querySelector('.button--primary').classList.add('js-email--validated') : this.querySelector('.button--primary').classList.remove('js-email--validated');
      });
      this.querySelector('#partial_overlay_email').addEventListener('keyup', () => {
        this.validateEmail(this.querySelector("#partial_overlay_email").value) ? this.querySelector('.button--primary').classList.add('js-email--validated') : this.querySelector('.button--primary').classList.remove('js-email--validated');
      });
      
      //submit event listeners
      this.querySelector("form").addEventListener("submit", (e) => {
        e.preventDefault();
        this.handleSubmit(this.querySelector("#partial_overlay_email").value);
      });
    });
  }
  initDYContent() {
    let content = window.Marlow?.partial_overlay?.copy;
    this.querySelector(".partial-overlay--header h3").innerHTML = content.title;
    this.querySelector(".partial-overlay--header p").innerHTML = content.description;
    this.querySelector(".partial-overlay--form > div p").innerHTML = content.disclaimer_text;
    this.querySelector(".button--container .button--primary").innerHTML = content.positive_cta;
    this.querySelector(".button--container > p span").innerHTML = content.negative_cta;
  }
  handleSubmit(email) {
    if (this.validateEmail(email)) {
      this.querySelector("#partial_overlay_email").classList.remove("email--error");
      this.querySelector(".error__label").classList.remove("active");
      this.postToOmetria(email);
    } else {
      this.querySelector("#partial_overlay_email").classList.add('email--error');
      this.querySelector('.error__label').classList.add('active');
    }
  }

  postToOmetria(email){
    const signupSrc = "partial_overlay";
    const timeStamp = new Date();
    const payload = {
        "@type": "contact",
        "@collection": signupSrc,
        "email": email,
        "@merge": true,
        "marketing_optin": "EXPLICITLY_OPTEDIN",
        "timestamp_subscribed": timeStamp.toISOString(),
        "properties": {"signup_source": signupSrc}
      };

    fetch("https://marlow-ometria.herokuapp.com/api/contact", {
      method: "POST",
      dataType: "json",
      mode: "cors",
      contentType: "application/json; charset=utf-8",
      headers: {
        "X-Brooklinen-Auth": "d61616c3e2a6cf59a0cc435a66c091d4",
        "content-type": "application/json; charset=utf-8",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.ometria_contact == "created") {
          //track email optin for Heap
          try {
            heap.track("Email Optin", { email: email, signup_source: signupSrc });
          } catch (e) {
            console.log(`Heap Error: ${e}`);
          }
          //LiveConnect Tracking - Email Submit
          window.liQ = window.liQ || [];
          window.liQ.push({
            event: "conversion",
            name: "email_signup",
            email: email,
          });
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          submittedEmail: email,
        });
        dataLayer.push({
          event: "dl_subscribe",
          formLocation: signupSrc,
        });
        // Custom DY event for cookies
        try {
          DYO.StorageUtils.set("_dy_esp_email", email, ["cookieStorage"]);
          document.cookie = "_dy_email_submited=true; path=/";
        } catch (e) {
          console.log("DYO " + e);
        }

        // Heap
        try {
          heap.identify(email);
          // Northbeam
          window.Northbeam.fireEmailCaptureEvent(email, signupSrc);
        } catch (e) {
          console.log("heap.identify " + e);
        }

        //Ometria Identify
        try {
          ometria.identify(email);
        } catch (e) {
          console.log("ometria.identify " + e);
        }
      });
    this.closeOverlay();
  }
  getDYCookieValue() {
    return (document.cookie.match(
      /^(?:.*;)?\s*_dy_email_submited\s*=\s*([^;]+)(?:.*)?$/
    ) || [, null])[1];
  }
  validateEmail(email) {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }
  toggleNudge(state){
    if(state == 'active'){
        document.querySelector(".header__inline-menu--right").classList.add("nudge--active");
        document.querySelector(".header__icon--mail").classList.add("nudge--active");
    } else {
        document.querySelector(".header__inline-menu--right").classList.remove("nudge--active");
        document.querySelector(".header__icon--mail").classList.remove("nudge--active");
    }
    
  }
  dispatchOverlayBackground() {
    const initOverlayBackground = new CustomEvent("init-overlay", {
      detail: this.getAttribute("data-label"),
    });
    document.querySelector(".header__icon--mail").classList.add("nudge--active-open");
    window.dispatchEvent(initOverlayBackground);
  }
  closeOverlay() {
    const closeOverlayBackground = new CustomEvent("close-overlay", {
      detail: this.getAttribute("data-label"),
    });
    window.dispatchEvent(closeOverlayBackground);
    document.querySelector(".header__icon--mail").classList.remove("nudge--active-open");
    if(this.getDYCookieValue()) this.toggleNudge();
  }
}

customElements.define("partial-overlay", PartialOverlay);
